import router from './router'
import store from '@/store'

import {getToken, setNameCode} from '@/utils/cookie'
import {getLoginPathByRole} from '@/utils/router/other'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'
import {interceptor, loginList} from '@/router/login'
import {replaceDocumentIconAndTitle} from '@/utils'
// import {getTenantNameCode} from '@/api/platform/tenant' // progress bar style
NProgress.configure({showSpinner: false}) // NProgress Configuration

// 白名单请求，首页改为门户可以直接访问
const whiteList = ['/404', '/', '/doctor/medical/record/index', '/manage/medical/record/sso']

/**
 * 验证白名单
 */
const verifyWhiteList = path => {
  return whiteList.indexOf(path) > -1
}

/**
 * 全局前置守卫
 */
router.beforeEach((to, from, next) => {
  NProgress.start() //  start progress bar

  // 租户编码赋值
  if (to.params.nameCode) {
    let tenantInfo = store.getters.tenantInfo
    if (!getToken() || !tenantInfo || (tenantInfo.nameCode && tenantInfo.nameCode === to.params.nameCode)) {
      setNameCode(to.params.nameCode)
      store.dispatch('refreshTenantInfo')
    }
  }
  // 过滤白名单路由
  if (verifyWhiteList(to.path)) {
    next()
  } else {
    getToken() ? handleHasToken(to, next) : handleNoToken(to, next)
  }

  NProgress.done() // finish progress bar
})

/**
 * 全局后置钩子
 */
router.afterEach((to, from) => {
  replaceDocumentIconAndTitle()
  NProgress.done() // finish progress bar
})

/**
 * 有token时
 */
const handleHasToken = (to, next) => {
  interceptor(to, next)
}

/**
 * 没有token时
 */
const handleNoToken = (to, next) => {
  if (to.path === '/') {
    // // 域名
    // let domainName = window.location.host.split(':')[0]
    // // 根据域名获取租户nameCode
    // getTenantNameCode(domainName, true)
    //   .then(({data}) => {
    //     if (data.code === 0) {
    //       setNameCode(data.data)
    //       next(`/${data.data}/login/doctor`)
    //     } else {
    //       handleNotRootPath(to, next)
    //     }
    //   })
    //   .catch(() => {
    //     handleNotRootPath(to, next)
    //   })
    next()
  } else {
    handleNotRootPath(to, next)
  }
}

const handleNotRootPath = (to, next) => {
  if (loginList.indexOf(to.name) > -1) {
    // 跳转到平台登录页面时， 清除租户信息
    if (to.name === 'LoginPlatform') {
      store.commit('SET_TENANT_INFO', '')
    }
    next()
  } else {
    next(getLoginPathByRole())
  }
}



// WEBPACK FOOTER //
// ./src/permission.js